export enum DRUGMANUFACTURER_FILTER_TYPE {
    WITH_ERRORS = 'with_errors',
}
